
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"72","height":"72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"72","height":"72","rx":"36","fill":"#fff","fill-opacity":".1"}}),_c('path',{attrs:{"d":"M21.824 31.884a1.667 1.667 0 00.522 2.71l3.388 1.453c.26.111.56-.015.665-.276.746-1.85 1.516-3.44 2.31-4.77.755-1.27 1.758-2.666 3.007-4.192a.506.506 0 00-.284-.815l-1.349-.285a3.217 3.217 0 00-1.625.083 3.337 3.337 0 00-1.375.833l-5.259 5.26zm6.96 5.052a.818.818 0 00.198.84l5.784 5.821c.22.222.547.303.843.202a25.388 25.388 0 005.224-2.486 28.004 28.004 0 005-3.98c2.445-2.444 4.264-5.236 5.459-8.374 1.026-2.697 1.437-5.24 1.233-7.628a1.438 1.438 0 00-1.314-1.314c-2.389-.202-4.931.216-7.628 1.253-3.139 1.21-5.93 3.036-8.375 5.48a27.504 27.504 0 00-3.98 5 25.543 25.543 0 00-2.444 5.186zm11.341-4.52c-.639-.638-.958-1.423-.958-2.354 0-.93.32-1.715.958-2.354.639-.638 1.424-.958 2.355-.958.93 0 1.714.32 2.353.959.64.638.959 1.423.959 2.353 0 .931-.32 1.716-.959 2.355s-1.423.958-2.353.958c-.931 0-1.716-.32-2.355-.958zm-2.143 17.8a1.667 1.667 0 002.706.512l5.229-5.228c.389-.389.666-.854.833-1.395a3.312 3.312 0 00.083-1.646l-.255-1.329a.506.506 0 00-.818-.293c-1.521 1.244-2.92 2.243-4.197 2.996-1.343.794-2.94 1.563-4.789 2.309a.504.504 0 00-.275.667l1.483 3.406zM22.75 42.75c.972-.972 2.153-1.465 3.542-1.48 1.388-.013 2.57.466 3.541 1.438.973.973 1.459 2.153 1.459 3.542 0 1.39-.487 2.57-1.459 3.542-.694.694-1.854 1.291-3.478 1.791-1.19.367-2.71.703-4.563 1.01a1.599 1.599 0 01-1.842-1.843c.306-1.849.642-3.362 1.008-4.541.5-1.612 1.098-2.764 1.792-3.459z","fill":"#fff","fill-opacity":".5"}})])
          )
        }
      }
    